import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  preview({ target }) {
    const theme = target.value
    const html = document.documentElement
    html.dataset.theme = theme
    if (theme === "system") {
      html.dataset.bsTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
    } else {
      html.dataset.bsTheme = theme
    }
    // Notify theme-switcher in nav so its pill stays in sync during preview
    document.dispatchEvent(new CustomEvent("theme:preview", { detail: { theme } }))
  }
}
